import axios, { AxiosInstance } from 'axios';
import mock from '@/../mocks/$mock';

const CHANNEL_ID =
  process.env.NODE_ENV === 'local' ? window.CHANNEL_ID || process.env.VUE_APP_CHANNEL_ID : window.CHANNEL_ID;
const baseDomain = process.env.VUE_APP_APP_ENDPOINT;
const baseURL = `${baseDomain}/${CHANNEL_ID}/retail/api`;

let repository: AxiosInstance;

/**
 * @note NODE_ENV: localの場合は、mockAPIを使用する
 * CS-4382 ローカルapp接続に対応
 */
if (process.env.NODE_ENV === 'local' && !process.env.VUE_APP_LOCAL_LINE_USER_ID) {
  repository = axios.create({ baseURL });
  // mock化
  mock(repository)
    .setDelayTime(1000)
    .enableLog();
} else {
  repository = axios.create({ baseURL, withCredentials: true /* 不要？ */ });
}

const __DEBUG__ = process.env.NODE_ENV !== 'production';

repository.interceptors.response.use(
  response => {
    if (__DEBUG__) {
      console.debug(
        `[${response.config.method?.toUpperCase()}] ${response.config.url} => ${response.status}`,
        response.data
      );
    }

    return response.data;
  },
  error => {
    if (__DEBUG__) {
      const res = error.response;
      if (res) {
        console.error(
          `[${res.config.method.toUpperCase()}] ${res.config.url} => ${res.status}`,
          error.response.data.message
        );
      }
    }

    const statusCode: number = error.response?.status;
    if (statusCode === 429) {
      console.warn('Too Many Requests - Redirecting to /error429');

      import('@/router').then(({ default: router }) => {
        router.push('/error429');
      });
    }

    return Promise.reject(error);
  }
);

export default repository;
